module.exports = __webpack_public_path__ + "static/mainImage-dfdbd21977a3ca8387b62ed9c115515f.jpg";